// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { PHOTO_PRODUCT_VIEW_CLASS_NAME } from "../../../../../core/constants/className";
import {
    IMAGES_ROUTE,
} from "../../../../../core/constants/route";
import {
    T_PHOTOS_HOSTING,
    T_PHOTOS_INTRO,
    T_PHOTOS_TITLE,
    T_PHOTOS_WEBSITE,
    T_SITE_NAME,
    T_COMMON_PRICE_WITH_PERIOD_EUR,
    T_MOVE_NOW,
    T_IMAGES_ROUTE_TITLE,
    T_IMAGES_ROUTE_DESCRIPTION,
} from "../../../../../core/constants/translation";
import { Product } from "../../../../../../../io/hyperify/core/store/types/product/Product";
import { useStoreProductList } from "../../../../../../../io/hyperify/frontend/hooks/useStoreProductList";
import { ProductType } from "../../../../../../../io/hyperify/core/store/types/product/ProductType";
import { ProductArticle } from "../../../common/productArticle/ProductArticle";
import { PHOTOS_IMAGE } from "../../../../assets/images";
import { LogService } from "../../../../../../../io/hyperify/core/LogService";
import { CurrencyUtils } from "../../../../../../../io/hyperify/core/CurrencyUtils";
import { getPriceTypeTranslationToken } from "../../../../../../../io/hyperify/core/store/constants/storeTranslation";
import { forEach } from "../../../../../../../io/hyperify/core/functions/forEach";
import { map } from "../../../../../../../io/hyperify/core/functions/map";
import { ProductPrice } from "../../../../../../../io/hyperify/core/store/types/product/ProductPrice";
import { BuyButton } from "../../../common/buyButton/BuyButton";
import { SENDANOR_PHOTO_WEBSITE } from "../../../../../core/constants/company";
import { TranslationFunction } from "../../../../../../../io/hyperify/core/types/TranslationFunction";
import { SEODiv } from "../../../common/seo/SEODiv";
import "./PhotoProductView.scss";

const LOG = LogService.createLogger('PhotoProductView');

export interface PhotoProductViewProps {
    readonly t?: TranslationFunction;
    readonly className?: string;
}

export function PhotoProductView (props: PhotoProductViewProps) {
    const t: TranslationFunction = props?.t ?? ((key: string): string => key);
    const className = props?.className;
    const description: readonly string[] = [ `${T_PHOTOS_INTRO}`, `${T_PHOTOS_WEBSITE}`, `${T_PHOTOS_HOSTING}` ];
    const productList: readonly Product[] = useStoreProductList(ProductType.PHOTO);
    LOG.debug(`Photo product: `, productList);

    const buttons: {readonly id: string, readonly product: Product, readonly price: ProductPrice, readonly label: string}[] = [];
    forEach(
        productList,
        (product: Product) => {
            forEach(
                product.prices,
                (price: ProductPrice) => {
                    const translationParams = {
                        AMOUNT: price ? CurrencyUtils.stringifySum(price.sum) : '',
                        VATLESS_AMOUNT: price ? CurrencyUtils.stringifySum(CurrencyUtils.getVatlessSum(price.sum, price.vatPercent)) : '',
                        PERIOD: price ? t(getPriceTypeTranslationToken(price.type)) : ''
                    };
                    buttons.push(
                        {
                            id: `${product.id}-${price?.type}`,
                            product,
                            price,
                            label: t(T_COMMON_PRICE_WITH_PERIOD_EUR, translationParams)
                        }
                    );
                }
            );

        }
    );
    LOG.debug(`PHOTO product: `, buttons);

    return (
        <SEODiv className={
            PHOTO_PRODUCT_VIEW_CLASS_NAME
            + (className ? ` ${className}` : "")
        }
                path={IMAGES_ROUTE}
                title={t(T_IMAGES_ROUTE_TITLE)}
                description={t(T_IMAGES_ROUTE_DESCRIPTION)}
                siteName={t(T_SITE_NAME)}
        >
            <article className={PHOTO_PRODUCT_VIEW_CLASS_NAME+'-article'}>

                <ProductArticle
                    t={t}
                    className={PHOTO_PRODUCT_VIEW_CLASS_NAME+'-article-content'}
                    previewImage={PHOTOS_IMAGE}
                    title={t(T_PHOTOS_TITLE)}
                    description={description}
                    // buyButtonProduct={productModel}
                    // buyButtonPrice={productPrice}
                    // buyButtonText={t(T_PHOTOS_ORDER_NOW, translationParams)}
                    secondaryButtonTo={SENDANOR_PHOTO_WEBSITE}
                    secondaryButtonText={t(T_MOVE_NOW)}
                >{map(
                    buttons,
                    (item) => <BuyButton key={item.id} product={item.product} price={item.price}>{item.label}</BuyButton>
                )}</ProductArticle>

            </article>

        </SEODiv>
    );
}
